import FormHelperText from '@material-ui/core/FormHelperText';
import classNames from 'classnames';
import Cleave from 'cleave.js/react';
import React from 'react';
import { AutoCompleteTypes } from '../MaskedTextField';
import styles from './FormattedInput.module.css';
export function FormattedInput(props) {
    var handleOnClick = function (event) {
        if (props.readOnly)
            return;
        if (props.disabled)
            return;
        if (props.onClick)
            props.onClick(event);
    };
    var handleBlur = function (event) {
        if (props.readOnly)
            return;
        if (props.disabled)
            return;
        if (props.onBlur) {
            props.onBlur(event);
        }
    };
    var handleFocus = function (event) {
        if (props.readOnly)
            return;
        if (props.disabled)
            return;
        if (props.onFocus)
            props.onFocus(event);
    };
    var handleMouseDown = function (event) {
        if (props.readOnly)
            return;
        if (props.disabled)
            return;
        if (props.onMouseDown)
            props.onMouseDown(event);
    };
    var onChange = function (event) {
        if (props.readOnly)
            return;
        if (props.disabled)
            return;
        if (props.onChange)
            props.onChange(event);
    };
    var autoCompleteValue = props.autoCompleteType === AutoCompleteTypes.UserInfo ? 'off-no-complete' : 'off';
    return (React.createElement("div", { className: classNames(styles.container, props.containerClass) },
        props.formatOptions ? (React.createElement(Cleave, { htmlRef: function (e) {
                // This is to map between useRef and normal functional refs. There may be a more elegant way to tackle this.
                if (props.inputRef)
                    props.inputRef.current = e;
            }, options: props.formatOptions, value: props.value, onChange: onChange, onClick: handleOnClick, autoComplete: autoCompleteValue, onBlur: handleBlur, onMouseDown: handleMouseDown, onFocus: handleFocus, disabled: props.disabled, style: props.style, placeholder: props.placeholder, readOnly: props.readOnly, maxLength: props.maxLength, className: props.className, autoFocus: props.autoFocus, "data-test-id": props.testId })) : (React.createElement("input", { ref: props.inputRef, autoFocus: props.autoFocus, value: props.value || '', onChange: onChange, onClick: props.onClick, onBlur: props.onBlur, onMouseDown: props.onMouseDown, onFocus: props.onFocus, disabled: props.disabled, style: props.style, placeholder: props.placeholder, readOnly: props.readOnly, maxLength: props.maxLength, className: props.className, "data-test-id": props.testId, autoComplete: autoCompleteValue })),
        (!props.hideWarningEmptyHelperText || props.errorText) && (React.createElement(FormHelperText, { classes: { root: styles.error } }, props.errorText || ' '))));
}
